module.exports = __webpack_public_path__ + "static/media/Moldflow Adviser Premium.320cd141.png";